// Author YuJiaBei
// Date 2022-01-06 15:49:12

class InspectionScheduleDetail {
constructor({
        id = null,
        inspectionScheduleId = '',
        emArchBasicDataCode = '',
        inspectionStandardId = '',
        eocName = '',
        eocId = '',
        name = '',
        order = ''}
= {}) {
    this.id = id;
    this.inspectionScheduleId = inspectionScheduleId;
    this.emArchBasicDataCode = emArchBasicDataCode;
    this.inspectionStandardId = inspectionStandardId;
    this.eocName = eocName;
    this.eocId = eocId;
    this.name = name;
    this.order = order;
}
}

function newEntity() {
return new InspectionScheduleDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBasicDataName',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectionScheduleName',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.inspectionScheduleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectName',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.projectName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectionStandards',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.inspectionStandards',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectionContents',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.inspectionContents',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocName',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.eocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'warningUpperLimit',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.warningUpperLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'warningLowerLimit',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.warningLowerLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dangerUpperLimit',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.dangerUpperLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dangerLowerLimit',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.dangerLowerLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'attachmentList',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'equipmentStatus',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.equipmentStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectionValueTypeName',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.inspectionValueTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectionValueTypeUnit',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.inspectionValueTypeUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectionWay',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.inspectionWay',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'order',
        label: 'label.em.inspection.inspectionScheduleDetail.grid.order',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    emArchBasicDataCodeFilter : '',
    inspectionScheduleIdFilter : '',
    inspectionStandardIdFilter : '',
    nameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.inspection.inspectionScheduleDetail.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'inspectionScheduleIdFilter',
        label: 'label.em.inspection.inspectionScheduleDetail.filter.inspectionScheduleId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'inspectionSchedule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inspectionStandardIdFilter',
        label: 'label.em.inspection.inspectionScheduleDetail.filter.inspectionStandardId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'inspectionStandard'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.inspection.inspectionScheduleDetail.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'inspectionScheduleId',
        label: 'label.em.inspection.inspectionScheduleDetail.entity.inspectionScheduleId',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'inspectionSchedule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.inspection.inspectionScheduleDetail.entity.emArchBasicDataCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'inspectionStandardId',
        label: 'label.em.inspection.inspectionScheduleDetail.entity.inspectionStandardId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'inspectionStandard'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"name":"inspectionValueTypeName"}'
                }
        },
        {
        key: 'eocName',
        label: 'label.em.inspection.inspectionScheduleDetail.entity.eocName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"eocId":"id"}'
                }
        },
        {
        key: 'name',
        label: 'label.em.inspection.inspectionScheduleDetail.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'order',
        label: 'label.em.inspection.inspectionScheduleDetail.entity.order',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {InspectionScheduleDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
